"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcludeAllDayEventFilter = void 0;
class ExcludeAllDayEventFilter {
    static filter({ eventPeriods, isDaysWithAllDayEventBookable }) {
        if (!isDaysWithAllDayEventBookable) {
            return eventPeriods;
        }
        return eventPeriods.filter((ep) => !ep.isAllDay);
    }
}
exports.ExcludeAllDayEventFilter = ExcludeAllDayEventFilter;
//# sourceMappingURL=excludeAllDayEventFilter.js.map